import { render, staticRenderFns } from "./jf_detail.vue?vue&type=template&id=5c02a5f4&scoped=true&"
import script from "./jf_detail.vue?vue&type=script&lang=js&"
export * from "./jf_detail.vue?vue&type=script&lang=js&"
import style0 from "./jf_detail.vue?vue&type=style&index=0&id=5c02a5f4&scoped=true&lang=scss&"
import style1 from "./jf_detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c02a5f4",
  null
  
)

export default component.exports